import type { ReceiptTemplate } from '../schema';

export const lowesTemplate: ReceiptTemplate = {
  id: 'lowes',
  name: "Lowe's Receipt",
  brand: "LOWE'S",
  description: "Home improvement store receipt template inspired by Lowe's",
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 9,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: 'none',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'lowes-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/lowes.png',
        logoData: '',
        logoWidth: 180,
        logoHeight: 70,
        businessName: '',
        businessNameFontSize: 22,
        addressLines: [
          "LOWE'S HOME CENTERS, LLC",
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608    (510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'lowes-divider-1',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 20,
      },
    },
    {
      id: 'lowes-sale',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '- SALE -',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'lowes-trans-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'SALES#: S2513US0 3644746    TRANS#: 18854480 07-09-21',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lowes-divider-2',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 20,
      },
    },
    {
      id: 'lowes-item-1',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '234567 OATEY 14-OZ PLUMBERS PUTT          2.99',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'lowes-item-2',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '345678 MR BBQ 18-IN GRILL BRUSH           4.99',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'lowes-item-3',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '456789 GORILLA GEL SUPER GLUE             5.94\n',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'lowes-item-4',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '567890 LOGIC 12 SKILLET                  23.97',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'lowes-item-5',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '678901 SS 6FT ROUND BEACH MAT            13.99',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lowes-totals',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '                            SUBTOTAL:    51.88\n                                 TAX:     4.28\n                 INVOICE 18934 TOTAL:    56.16\n                                VISA:    56.16',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'lowes-store-info',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'STORE: 1045    TERMINAL: 15    07/05/25     15:15:47',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
    {
      id: 'lowes-item-count',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '# OF ITEMS PURCHASED:                   5',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
    {
      id: 'lowes-excludes',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'EXCLUDES FEES, SERVICES AND SPECIAL ORDER ITEMS',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lowes-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '18854480251307092113145',
        showValue: false,
        width: 1.2,
        height: 35,
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'lowes-divider-3',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 14,
      },
    },
    {
      id: 'lowes-thanks',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: "THANK YOU FOR SHOPPING LOWE'S.",
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lowes-divider-4',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 14,
      },
    },
    {
      id: 'lowes-return-policy',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'FOR DETAILS ON OUR RETURN POLICY, VISIT\nLOWES.COM/RETURNS\nA WRITTEN COPY OF THE RETURN POLICY IS AVAILABLE\nAT OUR CUSTOMER SERVICE DESK',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lowes-divider-5',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 14,
      },
    },
    {
      id: 'lowes-manager',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'STORE MANAGER:  MIKE WAZOWSKI',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'lowes-divider-6',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 14,
      },
    },
    {
      id: 'lowes-price-promise',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: "LOWE'S PRICE PROMISE\nFOR MORE DETAILS, VISIT LOWES.COM/PRICEPROMISE",
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
    {
      id: 'lowes-divider-7',
      type: 'divider',
      enabled: true,
      config: {
        style: 'spaces',
        spacing: 14,
      },
    },
  ],
};
